<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="700">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Nuevo cliente.</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <div v-if="!cliente.id">
              <v-alert dense text type="error">
                El cliente solo debe registrarse una sola ves <strong>EVITE DUPLICAR </strong> clientes con el mismo
                numero de documento.
              </v-alert>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-combobox
                    v-model="filtroestudiante"
                    :items="estudiantes"
                    label="Buscar participante por documento:"
                    :loading="isloadingestudent"
                    loader-height="6"
                    placeholder="tecla enter para buscar..."
                    class="mr-0 mb-4 mt-2"
                    color="blue"
                    messages="Busque al estudiante para jalar sus datos como cliente."
                    outlined
                    dense
                  ></v-combobox>
                </v-col>
              </v-row>
              <!-- <v-divider class="mt-0 mb-8 blue"></v-divider> -->
              <p class="mb-1 primary--text"><b>Formulario para registrar nuevo cliente:</b></p>
            </div>

            <v-select
              label="* Tipo documento"
              v-model="cliente.tipo_documento_id"
              :items="tdocs"
              item-value="id"
              :readonly="ismoddatos || cliente.numero_documento == '99001'"
              prepend-inner-icon="mdi-book-outline"
              dense
              outlined
            ></v-select>
            <v-row no-gutters>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="* Numero de documento:"
                  v-model.trim="cliente.numero_documento"
                  @input="listenerdoc"
                  dense
                  outlined
                  class="mr-2"
                  prepend-inner-icon="mdi-badge-account-horizontal-outline"
                  :messages="cliente.is_verificado ? 'Nit verificado' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Complemento:"
                  v-model.trim="cliente.complemento"
                  prepend-inner-icon="mdi-book-arrow-left-outline"
                  :readonly="ismoddatos"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            
            <v-text-field
              label="* Razon social"
              v-model.trim="cliente.razon_social"
              :readonly="ismoddatos"
              prepend-inner-icon="mdi-account-multiple-outline"
              @input="upper('razon_social', $event)"
              dense
              outlined
            ></v-text-field>
            <v-text-field
              label="correo"
              v-model.trim="cliente.email"
              messages="Se usara un correo por defecto en caso de no llenar este campo."
              prepend-inner-icon="mdi-email"
              dense
              outlined
            ></v-text-field>
          </v-container>

          <p class="mb-0 text-center blue--text">{{ estadosistema.isOnline ? 'Sistema Online' : 'Sistema Offline' }}</p>
          <v-progress-linear indeterminate v-if="loadingestado" height="1" color="red" />
          <v-progress-linear indeterminate v-if="loading || verificandonit" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="">
          <v-btn v-if="permitirnit" text @click="save()" class="orange darken-2 ml-6" dark :disabled="loading">
            {{ cliente.id ? 'Continuar de todos modos' : 'Registrar de todos modos' }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!permitirnit"
            text
            @click="presave()"
            class="green darken-2"
            dark
            :disabled="loading || verificandonit || loadingestado"
          >
            {{ cliente.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
      <div v-show="false"><ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" /></div>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  import ABuscarPersona from '@/components/ABuscarPersona';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        ismoddatos: false,
        verificandonit: false,
        filtroestudiante: null,
        isloadingestudent: false,
        estudiantes: [],
        msg: '',
        tdocs: [],
        cliente: {
          id: null,
          email: null,
          razon_social: '',
          numero_documento: '',
          complemento: '',
          tipo_documento_id: null,
          is_verificado: false,
        },
        loadingestado: false,
        estadosistema: {
          isManual: true,
          isOnline: false,
        },
        permitirnit: false,
      };
    },
    components: { ABuscarPersona },
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.isloadingestudent = false;
          //this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          //this.getDatos();
          if (!this.filtroestudiante.seg_apellido) this.filtroestudiante.seg_apellido = '';
          this.cliente.razon_social = `${this.filtroestudiante.nombres} ${this.filtroestudiante.pri_apellido} ${this.filtroestudiante.seg_apellido}`
            .trim()
            .toUpperCase();
          this.cliente.numero_documento = this.filtroestudiante.num_doc;
          this.cliente.email = this.filtroestudiante.email;
          this.isloadingestudent = false;
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.isloadingestudent = false;
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
          this.isloadingestudent = false;
        }, 500);
      },
    },
    methods: {
      openmodal(item) {
        this.msg = '';
        this.filtroestudiante = '';
        this.dialog = true;
        this.ismoddatos = false;
        this.verificandonit = false;
        this.estadosistema.isOnline = false;
        this.permitirnit = false;
        this.getdocumentos();
        this.cliente.id = null;
        this.cliente.razon_social = '';
        this.cliente.numero_documento = '';
        this.cliente.email = null;
        this.cliente.complemento = '';
        this.cliente.tipo_documento_id = null;
        this.cliente.is_verificado = false;
        this.verificarOnline();
        if (item) {
          this.cliente.id = item.id;
          this.cliente.razon_social = item.razon_social;
          this.cliente.numero_documento = item.numero_documento;
          this.cliente.complemento = item.complemento;
          this.cliente.email = item.email;
          this.cliente.tipo_documento_id = item.tipo_documento_id;
          this.cliente.is_verificado = item.is_verificado;
          this.listenerdoc();
        }
      },
      getdocumentos() {
        let vue = this;
        //https://academicodev.esam.edu.bo/api/v1/esam/tiposdocumentos
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.text = `${x.descripcion_SIN} (${x.codigo_clasificador_SIN})`;
            });
            vue.tdocs = data;
            window.console.log('tdocs', response.data);
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      upper(v, ev) {
        if (!ev) return;
        ev = ev.replaceAll(';', '');
        this.cliente[v] = ev.toUpperCase();
      },
      verificarNITStatus() {
        if (!this.estadosistema.isOnline) {
          this.cliente.is_verificado = false;
          this.save();
          return;
        }
        this.verificandonit = true;
        this.msg = 'Verificando nit...';
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/verificarnit/${this.cliente.numero_documento}`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response.data);
            let data = response.data;
            if (data) {
              let ms = data.mensajesList;
              vue.msg = '';
              let t = '';
              ms.forEach((x) => {
                t += `${x.codigo} ${x.descripcion}`;
              });
              vue.msg = t;
              if (data.transaccion) {
                vue.verificandonit = false;
                vue.cliente.is_verificado = true;
                window.console.log('ressss', response.data);
                vue.save();
              } else {
                vue.cliente.is_verificado = false;
                //if (!vue.estadosistema.isOnline) {
                vue.permitirnit = true;
                //}
                vue.verificandonit = false;
                /* vue.msg += '... continuando con el registro...';
                setTimeout(() => {
                  vue.save();
                }, 5000);*/
              }
            }
          })
          .catch(function(error) {
            window.console.log(error);
            vue.msg = 'No se pudo verificar el NIT, puede que se haya ingresado mal el numero.';
            vue.verificandonit = false;
          });
      },
      verificarOnline() {
        let vue = this;
        vue.loadingestado = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/empresas/isonline`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarOnline', data);
            if (data) {
              vue.estadosistema.isManual = data.isManual;
              vue.estadosistema.isOnline = data.isOnline;
            }
            vue.loadingestado = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingestado = false;
          });
      },
      listenerdoc() {
        this.ismoddatos = false;
        if (this.cliente.numero_documento == '99001') {
          this.cliente.razon_social = 'PERSONERÍA JURÍDICA';
          this.cliente.tipo_documento_id = 5; // 2 es nit, en sin es 5
          this.cliente.complemento = '';
          // this.ismoddatos = true;
        } else if (this.cliente.numero_documento == '99002') {
          this.cliente.razon_social = 'CONTROL TRIBUTARIO';
          this.cliente.tipo_documento_id = 5; // 2 es nit, en sin es 5
          this.cliente.complemento = '';
          this.ismoddatos = true;
        } else if (this.cliente.numero_documento == '99003') {
          this.cliente.razon_social = 'VENTAS MENORES DEL DÍA';
          this.cliente.tipo_documento_id = 5; // 2 es nit, en sin es 5
          this.cliente.complemento = '';
          this.ismoddatos = true;
        }
        // window.console.log(this.cliente.numero_documento);
      },
      asyncfindestudiante() {
        this.isloadingestudent = true;
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      resultadobusquedaest() {
        window.console.log(this.estudiantes);
        this.isloadingestudent = false;
      },
      presave() {
        let tipo = this.tdocs.find((x) => x.id == this.cliente.tipo_documento_id);
        if (tipo && tipo.codigo_clasificador_SIN == 5) {
          this.verificarNITStatus();
        } else {
          this.save();
        }
      },
      save() {
        this.msg = '';
        /*if (this.filtroestudiante && typeof this.filtroestudiante == 'object') {
          this.cliente.numero_documento = this.filtroestudiante.num_doc;
        }*/
        if (!this.cliente.razon_social) this.msg = 'Ingrese la razon social.';
        if (!this.cliente.numero_documento) this.msg = 'Ingrese el numero de documento.';
        if (!this.cliente.tipo_documento_id) this.msg = 'Seleccione el tipo de documento.';
        /* if (this.cliente.email && !this.cliente.email.includes('@')) {
          this.msg = 'el formato del email no es el correcto.';
        } */
        /*let valid = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\\.\w{2,3})+$/.test(this.cliente.email);
        if (valid) {
          this.msg = 'El formato del correo no es el correcto.';
        }*/
        if (!this.cliente.email) {
          let unidad = this.$store.state.CARGO.sede.unidad_negocio;
          if (unidad == 1) this.cliente.email = 'facturas@esam.edu.bo';
          else if (unidad == 2) this.cliente.email = 'facturas@cca.edu.bo';
          else if (unidad == 10) this.cliente.email = 'facturas@esam.edu.bo';
        }
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.cliente.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/clientes`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.cliente,
        };

        xaxios.request(config)
          .then(async function(response) {
            let data = response.data;
            if (data.data.id) {
              vue.msg = `Registrado, ID:${data.data.id}`;
              // vue.$emit('newregcliente', data.data);

              let cliente = await xaxios
                .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/clientes/${data.data.id}`)
                .then(({ data }) => (data ? data : {}));
              vue.$emit('newregcliente', cliente);
            }
            window.console.log('clientenew::', data);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response);
            vue.loading = false;
            let data = error.response.data;
            if (typeof data == 'string') vue.msg = `Error: ${data}`;
            else vue.msg = `${data.data}`;
          });
      },
    },
  };
</script>
